import { SystemStyleObject } from "@chakra-ui/react";
import { StylesConfig } from "react-select";

export const businessFormWrapperCss: SystemStyleObject = {
  display: "flex",
  flexDirection: "column",
  gap: "32px",
  width: "100%",
};

export const addNewBusinessFormFooterCss: SystemStyleObject = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginTop: "32px",
};

export const triggerButtonsWrapperCss: SystemStyleObject = {
  display: "flex",
  justifyContent: "space-between",
  gap: "12px",
};

export const customStyledSelectStyles: StylesConfig = {
  valueContainer: (base) => ({
    ...base,
    padding: "0 0 0 14px",
    margin: 0,
  }),
  control: (base, state) => ({
    ...base,
    height: "48px",
    borderRadius: "8px",
    cursor: "pointer",
    borderColor: state.isFocused ? "#006770" : "#E2E4E8",
    borderWidth: state.isFocused ? "2px" : base.borderWidth,
    boxShadow: state.isFocused
      ? "rgba(0, 103, 112, 1)"
      : "0px 1px 2px 0px #1018280D",

    "&:focus": {
      borderColor: "#006770",
    },

    "&:hover": {
      borderColor: "#006770",
    },
  }),
};

export const onlinePresenceDropdownBtnCss: SystemStyleObject = {
  border: "1px solid #E2E4E8",
  boxShadow: "none",
  padding: "14px 16px",
  width: "181px",
  height: "49px",
  borderRadius: "8px",
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "21px",
  color: "#777E90",
};

export const onlinePresenceDropdownCss: SystemStyleObject = {
  maxHeight: "161px",
  borderRadius: "8px",
  border: "1px solid #F2F4F7",
  backgroundColor: "#ffffff",
  boxShadow: "0px 12px 16px -4px #10182814",
  padding: 0,
};
